(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);
  if (customElements.get('slides-variant-changer')) return;

  customElements.define('slides-variant-changer', class extends baseComponent.default {
    elements = {
      slideShow: 'slide-show'
    }

    render() {
      if (!this.$slideShow) return;
      this.listenTo('variantChange', (e, data) => {
        const featuredMedia = data?.variant?.featured_media || data?.variant?.featured_image;
        if (!featuredMedia?.position) return;

        this.$slideShow.slideTo(featuredMedia.position - 1);

        if (window.matchMedia('(max-width: 991px)').matches) {
          this._scrollToGallery();
        }
      });
    }

    _scrollToGallery() {
      const top = this.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth'
      });
    }
  });
})();
